<template>
  <v-breadcrumbs :items="items" class="px-0">
    <template v-slot:item="scope">
      <router-link
        class="title-font darkGray--text mr-2"
        v-if="scope.item.link"
        :to="scope.item.to"
        style="text-decoration: none"
      >
        <img :src="require('@/assets/ic_head_voltar.svg')" />
      </router-link>
      <span class="title-font darkGray--text">
        {{ nameBreadcrumb(scope.item.text) }}
      </span>
    </template>
    <template v-slot:divider>
      <v-icon color="error" class="breadcrumb--divider">
        mdi-chevron-right
      </v-icon>
    </template>
  </v-breadcrumbs>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "BaseBreadcrumb",
  computed: {
    ...mapState("modality", ["currentModality"])
  },
  methods: {
    nameBreadcrumb(item) {
      // Trocar Breadcrumb quando estiver lista de submodalidades
      return this.currentModality.nome &&
        this.$route.name == "list sub-modality"
        ? this.currentModality.nome
        : item;
    }
  },
  props: {
    items: {
      type: Array
    }
  }
};
</script>
<style lang="sass" scoped>
.v-breadcrumbs li .v-icon.breadcrumb--divider
  font-size: 20px
.title-font
  font-size: 20px
  font-weight: 700
  @media(max-width:600px)
    font-size: 16px
</style>
